import React, { useEffect } from "react";
import { Dimmer, Header, Image, Loader, Message } from "semantic-ui-react";
import logo from "../../assets/images/urbansim/logo.png";

const ConfirmRegistration = ({
  onConfirm,
  loading,
  showSuccessMessage,
  successMessageHeader,
  successMessageContent
}) => {
  useEffect(() => {
    onConfirm();
  }, [onConfirm]);
  return (
    <>
      <Image size="small" src={logo} style={{ margin: "auto", display: "inline-block" }} />
      <Header as="h1" textAlign="center">
        UrbanSim
      </Header>
      <Dimmer active={loading}>
        <Loader />
      </Dimmer>
      {showSuccessMessage && (
        <Message positive>
          <Message.Content>
            <Message.Header>{successMessageHeader}</Message.Header>
            {successMessageContent}
          </Message.Content>
        </Message>
      )}
    </>
  );
};

export default ConfirmRegistration;
